export default __webpack_public_path__ + "static/media/PU.517fe892.mp3";